import React from "react";
import { Box, Container, Typography, Link } from "@mui/material";

const ContactUs = () => {
  return (
    <Box sx={{ py: 10, bgcolor: "#FDFBF7" }}>
      {/* Top Contact Info */}
      <Container maxWidth="lg">
        <Typography
          className="overline-text"
          sx={{
            color: "#C59324",
            fontWeight: 700,
            letterSpacing: "0.2em",
            fontSize: "0.85rem",
            textTransform: "uppercase",
            mb: 2,
          }}
        >
          Contact us
        </Typography>

        <Typography
          className="headline-main"
          sx={{
            mb: "8px",
            color: "#333",
            fontWeight: 700,
            fontFamily: "'Playfair Display', serif",
            mt: 1,
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
        >
          Want to{" "}
          <Box
            component="span"
            sx={{
              color: "#C59324",
              fontFamily: "'Playfair Display', serif",
              fontStyle: "italic",
              fontWeight: 500,
            }}
          >
            contact Gary?
          </Box>
        </Typography>

        <Typography
          sx={{
            color: "#000",
            fontSize: "1.2rem",
            lineHeight: 1.8,
          }}
        >
          If you have anything on your mind, feel free to share it with us at
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", sm: "1.4rem" },
            color: "#555",
            mb: 8,
            wordBreak: "break-word",
            overflowWrap: "anywhere",
          }}
        >
          <Link
            href="mailto:friendsofgarytaylor@gmail.com"
            underline="hover"
            sx={{
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            friendsofgarytaylor@gmail.com
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default ContactUs;
